import { useCallback } from 'react';
import { authApi } from '@/sdk/shared';

export const useAuth = () => {
  const logout = useCallback(() => {
    authApi.logout();
  }, []);

  const getToken = useCallback(() => {
    return authApi.getToken();
  }, []);

  const isAuthenticated = useCallback(() => {
    return authApi.isAuthenticated();
  }, []);

  return {
    logout,
    getToken,
    isAuthenticated,
  };
};
